import type { $Fetch } from 'nitropack'

/**
 * Client-side fetch instance targeting the app's own BFF (`/api`).
 * Use for imperative calls (mutations/submits). Reactive SSR reads should
 * still use `useFetch`/`useAsyncData` (which can't consume a custom $fetch).
 */
export const useApi = (): $Fetch =>
  $fetch.create({
    baseURL: '/api',
    onRequest({ options }) {
      options.headers.set('Accept', 'application/json')
    },
    onResponseError({ response }) {
      // Centralized client-side error logging (extend with toast / 401 handling).
      console.error(`[API ${response.status}]`, response._data)
    },
  })
